import React, { Component } from "react";
import Link from "../../../Link.js";
import commonFunction from "../../../lib/utils/common.js";
import configUrl from "../../../../config/config.json";
import { logout } from "../../../lib/logout.js";
import { checksession } from "../../../lib/checksession.js";
import chat from "../../../lib/chat.js";
import FBPixCodeScript from "../../../analytics/FacebookPixelCode.js";
import Analytics from "../../../analytics/index.js";
import UploadLogo from "store/uploadLogo";
import MoreMenu from "../../Moremenu/index.js";
import GoogleTranslate from "../../googleTranslate/custom.js";
import { setCookiUserToken } from "../../../lib/login.js";
import getCurrencyList from "../../../lib/getCurrencyList.js";
import ModalPopupComponent from "../../ModalPopupComponent/theme12/ModalPopupComponent.js";
import { withRouter } from "next/router";
import CurrencyListSection from "../../../componentsV2/currency";
// import currencyStyle from "../../../componentsV2/currency/themeCss/theme12.module.css";

class Header12 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: false,
      userFirststname: "",
      isSubscribed: false,
      userType: "",
      openInitialPopup: false,
      onHoverSupport: false,
      transform: null,
      scrolling: false,
      openSupportPopup: false,
      openCurrencyPopup: false,
      activeLink: "",
      openMorePopup: false,
      pathname: "",
      isTranslationModal: false,
      language: "en",
      currency: commonFunction.getCookieTocken("selectedCurrency") || props?.data?.siteData?.site?.base_currency || "",
      currencyOptions: props?.data?.siteData?.site?.currencies || [],
      currencyOptionsPopular: [],
      currencyOptionsOther: [],
    };
    this.style = {
      color: "red",
    };
  }

  async componentDidMount() {

    const response = await getCurrencyList();
    const baseCurrency = this.props?.data?.siteData?.site?.base_currency;

    if (response?.status) {
      const popular = response?.data?.data?.popular || [];
      const other = response?.data?.data?.other || [];

      const activeCurrency =
        popular.find(c => c.status === "active") ||
        other.find(c => c.status === "active") ||
        popular[0] || other[0];


      this.setState({
        currencyOptionsPopular: popular,
        currencyOptionsOther: other,
        currency: activeCurrency?.code || baseCurrency || ""
      });

      if (activeCurrency && !commonFunction.getCookieTocken("selectedCurrency")) {
        commonFunction.setCookie("selectedCurrency", activeCurrency.code);
        commonFunction.setCookie("selectedCurrencyName", activeCurrency.name);
      } else if (!activeCurrency && baseCurrency && !commonFunction.getCookieTocken("selectedCurrency")) {
        commonFunction.setCookie("selectedCurrency", baseCurrency);
        commonFunction.setCookie("selectedCurrencyName", baseCurrency);
      }

    }

    const savedCurrency = commonFunction.getCookieTocken("selectedCurrency");
    if (savedCurrency) {
      this.setState({ currency: savedCurrency });
    } else if (baseCurrency) {
      this.setState({ currency: baseCurrency });
    }

    window.addEventListener("currencyChanged", this.updateCurrencyFromStorage);

    let url = window.location.pathname;
    if (this.props?.data?.siteData?.site?.allow_multilingual) {
      let googtransCookie = commonFunction.getCookie("googtrans");
      let language =
        googtransCookie != "" ? googtransCookie.split("/")[2] : "en";
      this.setState({ language });
    }
    this.setState({ pathname: url });

    let defaultService = this.props.data.headermenu.menu?.filter(
      (ele) => ele.status.toLowerCase() == "active"
    );
    if (defaultService?.length > 0) {
      this.setState({ activeLink: defaultService[0].code });
    }

    if (url.includes("holiday") || url.includes("holidays")) {
      this.setState({ activeLink: "Holidays" });
    }
    if (url.includes("flight") || url.includes("flights")) {
      this.setState({ activeLink: "Flights" });
    }
    if (url.includes("hotel") || url.includes("hotels")) {
      this.setState({ activeLink: "Hotels" });
    }
    if (url.includes("activity") || url.includes("activities")) {
      this.setState({ activeLink: "Activities" });
    }
    if (url.includes("car") || url.includes("cars")) {
      this.setState({ activeLink: "Cabs" });
    }
    //check if varification token is there
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousedown", this.handleCalendarClickOutside);
    chat(this.props?.data?.siteData?.site?.chat, this.props?.data?.isMobile);

    if (this.props?.data?.user?.status) {
      this.setState({
        userFirststname: this.props?.data?.user?.first_name
          ? this.props?.data?.user?.first_name.charAt(0) : "",
        userType: this.props?.data?.user?.type,
        isSubscribed: this.props?.data?.user?.is_subscribed
      });
    } else {
      this.setState({
        userFirststname: "",
        userType: "",
      });
    }
    // this.checkSessionApi()

    if (!this.props?.data?.user?.accessToken) {
      const urlParams = new URLSearchParams(window.location.search);
      const nativeview = urlParams.get("nativeview");
      const userToken = urlParams.get("userToken");

      if (
        (nativeview == "true" || localStorage.getItem("nativeView")) &&
        userToken
      ) {
        let userTokenReq = {
          userToken: userToken,
        };

        setCookiUserToken(userTokenReq).then((responseJSON) => {
          if (
            responseJSON.status === true &&
            responseJSON.accessToken !== "" &&
            responseJSON.accessToken !== undefined &&
            responseJSON.accessToken !== null
          ) {
            window.location.reload();
          }
        });
      }
    }
  }

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this.handleCalendarClickOutside);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("currencyChanged", this.updateCurrencyFromStorage);
  };

  setCalendarWrapperRef = (node) => {
    this.calendarWrapperRef = node;
  };

  setSupportWrapperRef = (node) => {
    this.supportWrapperRef = node;
  };
  setMoreWrapperRef = (node) => {
    this.MoreWrapperRef = node;
  };

  setCurrencyWrapperRef = (node) => {
    this.currencyWrapperRef = node;
  };

  handleScroll = (event) => {
    // console.log("clicked");
    if (window.scrollY <= 50 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
      // console.log("false");
    } else if (window.scrollY > 50 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
      // console.log("true");
    }
  };

  handleCalendarClickOutside = (event) => {
    if (
      !this.calendarWrapperRef ||
      !this.calendarWrapperRef.contains(event.target)
    ) {
      this.setState({ openInitialPopup: false });
    }

    if (
      !this.supportWrapperRef ||
      !this.supportWrapperRef.contains(event.target)
    ) {
      this.setState({ openSupportPopup: false });
    }
    if (!this.MoreWrapperRef || !this.MoreWrapperRef.contains(event.target)) {
      this.setState({ openMorePopup: false });
    }

    if (
      !this.currencyWrapperRef ||
      !this.currencyWrapperRef.contains(event.target)
    ) {
      this.setState({ openCurrencyPopup: false });
    }
  };

  shouldShowCurrencyPopup = () => {
    const { pathname, query } = this.props.router || {};

    if (pathname === '/') return true;

    if (pathname === '/myprofile') {
      return true;
    }
    if (pathname === '/activities' || pathname === '/hotels' || pathname === '/[index]') return true;

    if (pathname.startsWith('/search')) {
      return true;
    }


    return false;
  };


  checkSessionApi = () => {
    if (
      !commonFunction.isValueEmpty(this?.props?.data?.sessionData) &&
      !commonFunction.isValueEmpty(this?.props?.data?.sessionData) &&
      this?.props?.data?.sessionData?.status === true
    ) {
      this.setState(
        {
          userFirststname:
            !commonFunction.isValueEmpty(
              this?.props?.data?.sessionData?.email
            ) &&
            (!commonFunction.isValueEmpty(
              this?.props?.data?.sessionData?.first_name
            )
              ? this?.props?.data?.sessionData?.first_name.charAt(0)
              : this?.props?.data?.sessionData?.email.charAt(0)),
          userType:
            !commonFunction.isValueEmpty(
              this?.props?.data?.sessionData?.type
            ) && this?.props?.data?.sessionData?.type,
        },
        () => { }
      );
    } else {
      this.setState({
        userFirststname: "",
        userType: "",
      });
    }
  };

  onClickArrow = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };

  onMouseLeave = () => {
    this.setState({
      isShowPopup: false,
    });
  };

  // componentWillReceiveProps(state, props) {
  //     this.checkSessionApi()
  // }

  onClickProfile = () => {
    // commonFunction.redirectTo('/myprofile')
    window.location.href = "/myprofile";
  };

  handleCurrencySelect = (code, name) => {

    commonFunction.setCookie("selectedCurrency", code);
    commonFunction.setCookie("selectedCurrencyName", name);

    this.setState({
      currency: code,
      openCurrencyPopup: false
    });

    window.dispatchEvent(new Event("currencyChanged"));
    window.location.reload();
  };

  updateCurrencyFromStorage = () => {
    const code = commonFunction.getCookieTocken("selectedCurrency");
    const name = commonFunction.getCookieTocken("selectedCurrencyName");

    this.setState({
      currency: code,
      currencyName: name
    });
  };


  onClickLogout = () => {
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status === true ||
          responseJSON.message === "Logout successfull"
        ) {
          this.setState({
            userFirststname: "",
            userType: "",
          });
          // location.reload()

          if (this.props?.data?.siteData?.site?.business_b2b) {
            window.location.pathname != "/login"
              ? (window.location.href = "/login")
              : null;
          } else {
            window.location.reload();
            // commonFunction.redirectTo("/");
          }
        } else {
        }
      })
      .catch((err) => { });
  };

  myBookingClickHandler = () => {
    // commonFunction.redirectTo('/myprofile', { Linkindex: 1 })
    window.location.href = `/myprofile?Linkindex=1`;
  };

  setMorePopupHandler = () => {
    this.setState({
      openMorePopup: !this.state.openMorePopup,
    });
  };

  closeTranslationModal = () => {
    this.setState({ isTranslationModal: false });
  };

  handleCurrencyApply = () => {
    // Close the currency popup after applying
    this.setState({ openCurrencyPopup: false });
    // Here you can add additional logic to handle currency change
    // For example, update cookies, call API, etc.
  };


  render() {


    const signupStyle = {
      border: "1px solid #3479c5",
      margin: 12,
      borderRadius: 10,
    };

    const loginStyle = {
      border: "1px solid #3479c5",
      backgroundColor: "var(--buttons_color)",
      margin: 12,
      borderRadius: 10,
    };

    const activeTabStyle = {
      backgroundColor: "#cc0000",
    };

    let query = ""
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      query = params.get('pagetype')
    }
    const isHome = window.location.pathname === "/" || window.location.pathname === "/activities" || window.location.pathname == "/hotels" || window.location.pathname == "/activity/destination" || window.location.pathname == "/activity/top50" || query == "city" || window.location.pathname.startsWith('/activity/destination/') || window.location.pathname.startsWith('/activity/top50');
    const allowSubscription = this.props?.data?.siteData?.site?.allow_member_subscription;
    const ssoId = this.props?.data?.user?.loyalty_id
    return (
      <>


        {/* Header for HomePage starts */}
        {/* <FBPixCodeScript /> */}
        <Analytics {...this.props?.data?.siteData?.site?.analytics_module} />

        {(
          <header
            className={`${this.props.data.cssfile.new_header_wrap}
            ${isHome ? this.props.data.cssfile.header_transparent : this.props.data.cssfile.new_header_wrap_other_pages}
            ${this.state.scrolling ? this.props.data.cssfile.header_sticky : ""}`}
          >
            <div className={this.props.data.cssfile.header_section}>
              <div className="flex flex-row justify-between items-center container-1185 mx-auto">
                <div className={this.props.data.cssfile.header_Container}>
                  <div className={this.props.data.cssfile.header_logomain}>
                    <Link
                      title="Logo"
                      key={"logo"}
                      href='/'
                      reloadOnClick
                      // onclick="window.location.href='/'"
                      //onClick={() => { window.location.href = this.props.data.headermenu.supportlink }}
                      className=""
                    >
                      <img
                        className={this.props?.data?.cssfile?.header_logo_}
                        src={`${"/shared/api/media/" +
                          (isHome ? (
                            UploadLogo?._currentValue?.isLogo
                              ? this.props?.data?.headermenu?.secondary_logo || this.props?.data?.headermenu?.logo
                              : this.props?.data?.headermenu?.secondary_logo || this.props?.data?.headermenu?.logo
                          ) : (
                            UploadLogo?._currentValue?.isLogo
                              ? this.props?.data?.headermenu?.logo
                              : this.props?.data?.headermenu?.logo
                          ))
                          }`}
                        alt="logodata"
                      />
                    </Link>
                    {allowSubscription && (
                      <Link
                        href={
                          this.state.isSubscribed
                            ? "/myprofile?activeTab=membership"
                            : "/membership"
                        }
                      >
                        <div className={this.props.data.cssfile.bb_membership}>
                          <img
                            src={isHome ? "/images/BB_white.svg" : "/images/BB_Black.svg"}
                            alt="membership_icon"
                          />
                          <span>BB-Pass Membership</span>
                        </div>
                      </Link>
                    )}

                  </div>


                  {/* <div className={this.props.data.cssfile.header_allService}>
                    <div>
                      <div
                        className={this.props.data.cssfile.header_all_section}
                      >
                        {!commonFunction.isValueEmpty(this.props) &&
                          !commonFunction.isValueEmpty(this.props.data) &&
                          !commonFunction.isValueEmpty(
                            this.props.data.headermenu
                          ) &&
                          !commonFunction.isValueEmpty(
                            this.props.data.headermenu.menu
                          ) &&
                          this.props.data.headermenu.menu
                            .filter(
                              (ele) => ele.status.toLowerCase() == "active"
                            )
                            .slice(0, 7)
                            .map(
                              (link, i) =>
                                link?.status.toLowerCase() === "active" && (
                                  <div
                                    key={"headerMenu" + i}
                                    className={`${this.props.data.cssfile.header_sections
                                      } ${this.state.activeLink.toLowerCase() ==
                                        link.code.toLowerCase()
                                        ? this.props.data.cssfile.active_hometab
                                        : ""
                                      }`}
                                  >
                                    {link.text != "Offline" &&
                                      link.code != "others" ? (
                                      <Link
                                        title={link.text}
                                        key={link.text}
                                        href={link.url}
                                        className=""
                                      >
                                        {link.text}
                                        <img
                                          src={`${"/shared/api/media/" +
                                            this.props?.data?.siteData?.site
                                              .id +
                                            "/" +
                                            link.icon
                                            }`}
                                          alt={link.text}
                                        />
                                      </Link>
                                    ) : (
                                      <a
                                        title={link.text}
                                        key={link.text}
                                        href={link.url}
                                        target="_blank"
                                        className=""
                                      >
                                        {link.text}
                                        <img
                                          src={`${"/shared/api/media/" +
                                            this.props?.data?.siteData?.site
                                              .id +
                                            "/" +
                                            link.icon
                                            }`}
                                          alt={link.text}
                                        />
                                      </a>
                                    )}
                                  </div>
                                )
                            )}
                        { }
                        {this.props.data.headermenu.menu.filter(
                          (ele) => ele.status.toLowerCase() == "active"
                        ).length > 7 && (
                            <MoreMenu
                              menuItems={this.props.data.headermenu.menu.slice(7)}
                              styles={this.props.data.cssfile}
                              setMoreWrapperRef={this.setMoreWrapperRef}
                              state={this.state.openMorePopup}
                              setMorePopupHandler={this.setMorePopupHandler}
                              site_id={this.props?.data?.siteData?.site.id}
                              showIcon={false}
                            />
                          )}
                      </div>
                    </div>
                  </div> */}

                  <div className={this.props.data.cssfile.login_container}>
                    {/* <div className={this.props.data.cssfile.download_btn_cont}>
                      <button
                        className={this.props.data.cssfile.download_button}>
                        <img src="images/mobile.png" alt="download-app" />
                        Download App
                      </button>
                    </div> */}

                    {/* <div className={this.props.data.cssfile.header_help_wrapper}>
                      <img src="/images/header_help.svg" alt="help_icon" />
                     <p>Help</p>
                     </div>

                      <div className={this.props.data.cssfile.header_help_wrapper}>
                      <img src="/images/header_bag.svg" alt="help_icon" />
                     <p>Manage Booking</p>
                     </div> */}

                    <div
                      className={this.props.data.cssfile.suport_cont}
                      ref={this.setSupportWrapperRef}
                    >
                      {/* <div
                        className={this.props.data.cssfile.znth_support}
                        onClick={() => {
                          this.setState({
                            openSupportPopup: !this.state.openSupportPopup,
                          });
                        }}
                      >
                        <span>Support</span>
                        <span className={this.props.data.cssfile.dropZ_arrow}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="7"
                            height="7"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M3.502 6.413.142.6h6.719L3.502 6.413z"
                            />
                          </svg>
                        </span>
                      </div> */}
                      {this.state.openSupportPopup && (
                        <div
                          className={this.props.data.cssfile.supportdropNew}
                          style={{ display: "block" }}
                        >
                          <a
                            href={`tel:${this.props?.data?.siteData?.site?.support_number}`}
                          >
                            <div
                              className={this.props.data.cssfile.header_menuZth}
                            >
                              <img src="/images/et-hd-phn.png" alt="" />
                              {/* +971 58 953 9988 */}
                              {this.props?.data?.siteData?.site?.support_number}
                            </div>
                          </a>
                          <a
                            href={`mailto:${this.props?.data?.siteData?.site?.support_email}`}
                          >
                            <div
                              className={this.props.data.cssfile.header_menuZth}
                            >
                              <img
                                src="/images/et-hd-email.png"
                                alt=""
                                width="20px"
                                height="20px"
                              />
                              {/* connect@elevatetrips.com */}
                              {this.props?.data?.siteData?.site?.support_email}
                            </div>
                          </a>
                        </div>
                      )}
                    </div>

                    {/* <GoogleTranslate
                      style={this.props.data.cssfile.translate_element}
                    /> */}
                    <ul
                      // style={{ display: this.props?.data?.showTranslation ? "block" : "none" }}
                      className={
                        this.props?.data?.showTranslation
                          ? this.props.data.cssfile.navbar_right
                          : `${this.props.data.cssfile.navbar_right} ${this.props.data.cssfile.handle_pointer}`
                      }
                      ref={this.setCurrencyWrapperRef}
                    >
                      <li
                        className={this.props.data.cssfile.dropdown}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({
                            isTranslationModal: !this.state.isTranslationModal,
                          });
                        }}
                      >
                        <span className={this.props.data.cssfile.dropdown_span}>
                          {/* <img
                            src="/images/india-flag.png"
                            alt="flag"
                            width="20px"
                            height="20px"
                          /> */}
                          <div
                            className={this.props.data.cssfile.znth_main}
                            onClick={(e) => {
                              if (!this.shouldShowCurrencyPopup()) return;
                              e.stopPropagation();
                              this.setState({
                                openCurrencyPopup:
                                  !this.state.openCurrencyPopup,
                              });
                            }}
                          >
                            <span>{this.state.currency}</span>

                            {/* <span
                              className={this.props.data.cssfile.dropZ_arrow}>
                              â–¾
                            </span> */}

                            {this.shouldShowCurrencyPopup() && (
                              <img
                                src="/images/header_drop_white.svg"
                                alt="drop"
                              />
                            )}

                          </div>
                          {/* {this.state.openCurrencyPopup && ( */}
                          {
                            this.shouldShowCurrencyPopup() && (
                              <div className={this.props.data.cssfile.settings_wrap}>
                                <ModalPopupComponent
                                  isMobile={false}
                                  isPopup={this.state.openCurrencyPopup}
                                  onClosePopup={() =>
                                    this.setState({ openCurrencyPopup: false })
                                  }
                                  modalCss={this.props.data.modalCss}
                                  showCrossButton={true}
                                  showBackButton={false}
                                // onBackPopup={() => {
                                //   if (this.registerRef.current) {
                                //     const step = this.registerRef.current.state.currentStep;
                                //     if (step === "email") {
                                //       if (onClickCross) onClickCross();
                                //     } else {
                                //       this.registerRef.current.handleBack();
                                //     }
                                //   }
                                // }}
                                >
                                  <div className={this.props.data.cssfile.currency_info_parent}>
                                    <CurrencyListSection
                                      isMobile={false}
                                      title="Popular currencies"
                                      list={this.state.currencyOptionsPopular}
                                      activeCurrency={this.state.currency}
                                      styles={this.props.data.cssfile}
                                      onSelectCurrency={this.handleCurrencySelect}
                                    />
                                    <CurrencyListSection
                                      isMobile={false}
                                      title="Other currencies"
                                      list={this.state.currencyOptionsOther}
                                      activeCurrency={this.state.currency}
                                      styles={this.props.data.cssfile}
                                      onSelectCurrency={this.handleCurrencySelect}
                                    />
                                  </div>

                                </ModalPopupComponent>

                              </div>
                            )
                          }

                          {/* )} */}
                          {/* <img src="/theme2/down_arrow.png" className={this.props.data.cssfile.drop_arrow} alt=""/> */}
                        </span>
                      </li>

                      {/* Language currency dropdown */}
                      {this.state.isTranslationModal &&
                        this.props?.data?.siteData?.site
                          ?.allow_multilingual && (
                          <GoogleTranslate
                            style={this.props.data.googleTransalationCss}
                            isMobile={false}
                            closeTranslationModal={this.closeTranslationModal.bind(
                              this
                            )}
                            isHomePage={
                              this.props?.data?.siteData?.site
                                ?.allow_multilingual
                            }
                            site_multi_languages={
                              this.props?.data?.siteData?.site
                                ?.site_multi_languages
                            }
                          />
                        )}
                      {/* Language currency dropdown */}
                    </ul>
                    <Link href={"/faq"}
                      className={this.props.data.cssfile.header_help_wrapper}>

                      <img src="/images/header_help.svg" alt="help_icon" />
                      <span>Help</span>
                      {/* </div> */}
                    </Link>

                    {!this.props?.data?.user?.first_name &&
                      <div
                        className={this.props.data.cssfile.header_help_wrapper}
                        onClick={() => {
                          this.props.data?.handleManageBooking(true);
                        }}
                      >
                        <img src="/images/manage_booking_white.svg" alt="manage booking" />
                        <span>Manage Booking</span>
                      </div>}

                    <div
                      className={this.props.data.cssfile.afterlogin}
                      ref={this.setCalendarWrapperRef}
                      onClick={() => {
                        this.onClickArrow();
                      }}
                    >

                      {ssoId || (this.state.userFirststname != undefined &&
                        this.state.userFirststname != null &&
                        this.state.userFirststname != "") ? (
                        <div className={this.props.data.cssfile.afterloginNew}>
                          {ssoId ? <div className={this.props.data.cssfile.user_avatar}>
                            <span className={this.props.data.cssfile.user_code}>
                              {'Hi'}
                            </span>
                            <span className={this.props.data.cssfile.user_name}>
                              {`${ssoId}`}
                            </span>
                          </div> : <div className={this.props.data.cssfile.user_avatar}>
                            <span className={this.props.data.cssfile.user_code}>
                              {this.state.userFirststname}
                            </span>
                            <span className={this.props.data.cssfile.user_name}>
                              {`${this.props?.data?.user?.first_name} `}
                            </span>
                          </div>}
                          <span
                            className={`${this.props.data.cssfile.afterloginArrow} ${this.state.isShowPopup ? this.props.data.cssfile.arrow_open : ""
                              }`}
                            onClick={() => {
                              this.onClickArrow();
                            }}
                          >
                            <img src="/images/downarrow_black.svg" alt="My Account" />
                          </span>
                          <div
                            className={`${this.props.data.cssfile.profile_details} ${this.state.isShowPopup ? this.props.data.cssfile.show : ""
                              }`}
                            onMouseLeave={() => {
                              this.onMouseLeave();
                            }}
                          >
                            {/* <div className={styles.profile_frst}> */}
                            <div
                              className={this.props.data.cssfile.profile_frst}
                            >
                              {!ssoId && (<div className={this.props.data.cssfile.user_avatar}>
                                <span className={this.props.data.cssfile.user_code}>
                                  {this.state.userFirststname}
                                </span>
                                <div className={this.props.data.cssfile.user_info}>
                                  <span className={this.props.data.cssfile.user_info_name}>
                                    {`${this.props?.data?.user?.first_name} `}
                                  </span>
                                  <span className={this.props.data.cssfile.user_email}>
                                    {`${this.props?.data?.user?.email}`}
                                  </span>
                                </div>
                              </div>)}
                              {!ssoId && <hr className={this.props.data.cssfile.divider_line} />}
                              <div className={this.props.data.cssfile.menu_links}>
                                <span className={this.props.data.cssfile.menu_item}
                                  onClick={() => {
                                    this.onClickProfile();
                                  }}
                                >
                                  {" "}
                                  <div
                                    className={this.props.data.cssfile.menu_icon}
                                  >
                                    <img
                                      type="image"
                                      src="/images/profile_grey.svg"
                                      alt="profile"
                                    />
                                  </div>
                                  My Profile
                                </span>

                                <span className={this.props.data.cssfile.menu_item}
                                  onClick={() => {
                                    this.onClickLogout();
                                  }}
                                >
                                  {" "}
                                  <div
                                    className={this.props.data.cssfile.menu_icon}
                                  >
                                    <img
                                      type="image"
                                      src="/images/logout_grey.svg"
                                      alt="Logout"
                                    />
                                  </div>
                                  Logout
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={this.props.data.cssfile.login_btn}
                          // onClick={this.props.data.onClickHeaderLoginB2C}
                          onClick={() => {
                            // this.setState({ openInitialPopup: true });
                            if (window.location.pathname !== "/login") {
                              const currentPath =
                                window.location.pathname + window.location.search;

                              sessionStorage.setItem("postLoginRedirect", currentPath);
                            }
                            this.props.data.onClickHeaderLogin("LogIn");
                          }}
                        >
                          <a href="#" title="My Account">

                            <div
                              className={this.props.data.cssfile.Login_btn_cont}
                            >
                              <button
                                className={this.props.data.cssfile.login_button}
                              >
                                <img
                                  src="/images/header_user.svg"
                                  alt="user_icon"
                                />
                                Login / Register
                              </button>
                            </div>

                          </a>
                        </div>
                      )}

                      {this.state.openInitialPopup && (
                        <div
                          className="logindrop"
                          id="loginDrop"
                          style={{
                            display: "block",
                            width: 140,
                            borderRadius: 10,
                            top: 60,
                          }}
                        >
                          <div
                            className="ax-head-menu"
                            style={loginStyle}
                            onClick={() => {
                              this.props.data.onClickHeaderLogin("LogIn");
                            }}
                          >
                            <img
                              style={{ filter: "brightness(100)" }}
                              type="image"
                              src="/images/loginew.svg"
                              alt=" Login"
                            />
                            <span style={{ color: "white" }}> Login</span>
                          </div>
                          <div
                            className="ax-head-menu"
                            style={signupStyle}
                            onClick={() => {
                              this.props.data.onClickHeaderLogin("LogIn");
                              // commonFunction.redirectTo("/signin", { s: "1" });
                            }}
                          >
                            <img
                              type="image"
                              src="/images/registere.svg"
                              alt="Register"
                            />
                            <span>Register</span>
                          </div>
                        </div>
                      )}
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </header>
        )}

        {/* Header for HomePage ends */}

        {/* Header for other pages starts */}

        {/* Header for other pages ends */}
      </>
    );
  }
}

export default withRouter(Header12);
